import React, { useState, ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { getTheme } from '../assets/styles/Theme';

type ThemeContextType = {
    darkMode: 'light' | 'dark',
    toggleDarkMode: () => void,
};

export const ThemeContext = React.createContext<ThemeContextType>({
    darkMode: 'light',
    toggleDarkMode: () => { },
});

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
    const initialMode = localStorage.getItem('mode') as 'light' | 'dark' | null;
    const [darkMode, setDarkMode] = useState<'light' | 'dark'>(initialMode || 'light');

    const toggleDarkMode = () => {
        const nextMode = darkMode === 'dark' ? 'light' : 'dark';
        setDarkMode(nextMode);
        localStorage.setItem('mode', nextMode);
    };

    const theme = getTheme(darkMode);

    return (
        <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
            <MuiThemeProvider theme={theme}>
                <StyledThemeProvider theme={theme}>
                    {children}
                </StyledThemeProvider>
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
}
